import { useTranslation } from 'react-i18next';
import { setLanguage, type AppLanguage } from '../i18n';

const OPTIONS: Array<{ value: AppLanguage; label: string }> = [
  { value: 'fr', label: 'FR' },
  { value: 'en', label: 'EN' },
];


export function LanguageToggle({ compact = true }: { compact?: boolean }) {
  const { t, i18n } = useTranslation();
  const current: AppLanguage = i18n.language.startsWith('en') ? 'en' : 'fr';

  return (
    <div className={`segmented lang-toggle${compact ? ' lang-toggle--compact' : ''}`} role="radiogroup" aria-label={t('language.label')}>
      {OPTIONS.map(({ value, label }) => (
        <button
          key={value}
          type="button"
          role="radio"
          aria-checked={current === value}
          aria-label={t(value === 'fr' ? 'language.french' : 'language.english')}
          onClick={() => setLanguage(value)}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
